// actions/password/token.js

function hashCode(s) {
  if (!s)
    return '';

  var h = 0, l = s.length, i = 0;
  if ( l > 0 )
    while (i < l)
      h = (h << 5) - h + s.charCodeAt(i++) | 0;
  return h;
}

export function tokenHasErrored(bool) {
  return {
    type: 'TOKEN_HAS_ERRORED',
    hasErrored: bool
  };
}

export function tokenIsLoading(bool) {
  return {
    type: 'TOKEN_IS_LOADING',
    isLoading: bool
  };
}

export function tokenFetchDataSuccess(response) {
  return {
    type: 'TOKEN_FETCH_DATA_SUCCESS',
    response
  };
}

export function tokenFetchData(host, username) {
  return (dispatch) => {
    dispatch(tokenIsLoading(true));
    dispatch(tokenHasErrored(false));
    dispatch(tokenFetchDataSuccess({
      token: Math.abs(hashCode(username)),
      phone: '+1 714-710-3590' 
    }));
    dispatch(tokenIsLoading(false));
  };
}